import { OptionGrid, StepHeader, Field } from "./common";
import { Input } from "@coremonit/design-system";
import type { DeploymentType } from "@coremonit/types";
import type { WizardData } from "../wizardStore";
import { Container, Cloud, Server, Cpu } from "lucide-react";

const OPTIONS: Array<{ value: DeploymentType; label: string; description: string }> = [
  { value: "kubernetes", label: "Kubernetes",  description: "Self-managed / bare k8s cluster." },
  { value: "docker",     label: "Docker",      description: "Plain Docker daemon or Docker Swarm." },
  { value: "ecs",        label: "AWS ECS",     description: "Elastic Container Service (Fargate or EC2)." },
  { value: "eks",        label: "AWS EKS",     description: "Managed Kubernetes on AWS." },
  { value: "aks",        label: "Azure AKS",   description: "Managed Kubernetes on Azure." },
  { value: "gke",        label: "Google GKE",  description: "Managed Kubernetes on GCP." },
  { value: "vm",         label: "Virtual Machine", description: "systemd service on an EC2/VM." },
  { value: "baremetal",  label: "Bare Metal",  description: "Physical host, no virtualization." },
  { value: "nomad",      label: "Nomad",       description: "HashiCorp Nomad workload scheduler." },
  { value: "openshift",  label: "OpenShift",   description: "Red Hat OpenShift Container Platform." },
];

interface Props { data: WizardData; update: (p: Partial<WizardData>) => void }

export function Step2Deployment({ data, update }: Props) {
  return (
    <div>
      <StepHeader title="Deployment type" description="Pick where this service runs so we know how to attach agents, watch health, and read manifests." />
      <OptionGrid<DeploymentType>
        value={data.deploymentType}
        onChange={(v) => update({ deploymentType: v })}
        options={OPTIONS.map(o => ({ ...o, icon: <Container size={14} /> }))}
        cols={3}
      />
      <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
        <Field label="Cluster / project"><Input value={data.cluster ?? ""} onChange={(v) => update({ cluster: v })} placeholder="prod-eks-01" /></Field>
        <Field label="Namespace / group"><Input value={data.namespace ?? ""} onChange={(v) => update({ namespace: v })} placeholder="core" /></Field>
        <Field label="Region"><Input value={data.region ?? ""} onChange={(v) => update({ region: v })} placeholder="us-east-1" /></Field>
      </div>
    </div>
  );
}
